export const BlogHero = () => {
  return (
    <section className="py-20 px-4 bg-gradient-to-r from-blue-50 to-indigo-50">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-4xl font-bold mb-6 text-gray-900">
          Our Blog
        </h1>
        <p className="text-xl text-gray-600">
          Insights, updates, and expert advice on digital marketing, business development, automation, and AI-driven solutions to help your business grow and innovate
        </p>
      </div>
    </section>
  );
};